import React, { useEffect, useState, useRef } from "react";
import { AntdButton, DatePickerField, SelectInput, InputField } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import { handleKeyDown } from "../../../blueplanitUtils/DatePickerAutoformate";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useSelector, useDispatch } from "react-redux";
import { GetAllRecords } from "../../../Slices/Thunk/Reports";
import { ConvertMsIntoTime } from "./convertIntoTime";
import { addDurations } from "./convertIntoTime";
import { checkDueStatus, GetDueDateTemp } from "./autoDueDate";
import { setLoader } from "../../../Slices/loaderSlice";
import { handleExport } from "./Export";
import { getOptionsByPath } from "../../../utilsdata";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { REPORTS, REPORTS_BILLABLE } from "../../../Dropdownmanager";
export const RecordClientReport = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.Reports.AllRecords);
    const clientOptions = useSelector((state) => state.clients.clients);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableData, setTableData] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const [overalTime, setTime] = useState();
    const dropdownRef = useRef(null);

    const [form, setForm] = useState({});
    const startOfMonth = dayjs().startOf("month").toDate();
    const endOfMonth = dayjs().endOf("month").toDate();
    const activeClientOptions = clientOptions
        ?.filter(client => client?.status === "Active" || client?.status === "active")
        .map(client => ({
            label: client?.clientName,
            value: client?.clientName,
        }));

    const handleInputChange = (e) => {
        const name = e?.target?.name;
        const value = e?.target?.value;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [dateErrors, setDateErrors] = useState({});

    const handleDateChange = (date, name) => {
        const isToField = name === 'requestReceivedTo' || name === 'requestDueTo';
        const formatted = date
            ? isToField
                ? dayjs(date).endOf('day').format("YYYY-MM-DDTHH:mm:ssZ")
                : dayjs(date).startOf('day').format("YYYY-MM-DDTHH:mm:ssZ")
            : null;

        setForm(prev => {
            const updated = { ...prev, [name]: formatted };
            const errors = {};
            if (updated.requestReceivedFrom && updated.requestReceivedTo &&
                dayjs(updated.requestReceivedTo).isBefore(dayjs(updated.requestReceivedFrom))) {
                errors.received = "\"To\" date cannot be before \"From\" date.";
            }
            if (updated.requestDueFrom && updated.requestDueTo &&
                dayjs(updated.requestDueTo).isBefore(dayjs(updated.requestDueFrom))) {
                errors.due = "\"To\" date cannot be before \"From\" date.";
            }
            setDateErrors(errors);
            return updated;
        });
    };

    const handleSubmit = async () => {
        if (Object.keys(dateErrors).length > 0) return;
        try {
            setCurrentPage(1)
            if (Object.keys(form).length > 0) {
                dispatch(setLoader(true))
                const ftch = { ...form, page: currentPage }
                await dispatch(GetAllRecords(ftch));
            }
        } catch (error) {
            dispatch(setLoader(false))
        }
    };
    const handleClear = async () => {
        try {
            setCurrentPage(1);
            setDateErrors({});
            dispatch(setLoader(true));
            const val = { startOfMonth, endOfMonth, page: 1 };
            await dispatch(GetAllRecords(val));
            setForm({});
        } catch (error) {
            dispatch(setLoader(false));
        }
    };
    useEffect(() => {
        dispatch(setLoader(true))
        let TotalTime = 0;
        const recordsWithTime = data?.records?.map((record, index) => {
            let totalTimeWorked = 0;
            let totalOtherTime = 0;

            if (Array.isArray(record?.metaInfo)) {
                record?.metaInfo?.forEach(({ startTime, endTime, taskType }) => {
                    let start = Number(startTime);
                    let end = Number(endTime);

                    // If endTime is missing, set start = 0
                    if (!endTime) {
                        start = 0;
                    }

                    if (!isNaN(start) && !isNaN(end)) {
                        const duration = end - start;

                        if (taskType?.toLowerCase().includes("processing") || taskType?.toLowerCase().includes("email")) {
                            totalTimeWorked += duration;
                        } else {
                            totalOtherTime += duration;
                        }
                    }
                });
            }

            TotalTime += (totalTimeWorked + totalOtherTime);
            setTime(TotalTime)
            return {
                ...record,
                rowId: `${record.requestId || 'rec'}-${index}`,
                billable: totalTimeWorked,
                Non_billable: totalOtherTime,
                processedBy: record?.employeeInfo?.[0]?.createdByName || record?.emailDetails?.[0]?.createdByName || 'N/A',

            };
        });
        recordsWithTime?.reverse();
        setTableData(recordsWithTime);


        dispatch(setLoader(false))
    }, [dispatch, data?.records,])

    useEffect(() => {
        (async () => {
            try {
                dispatch(setLoader(true))
                const isFormEmpty = Object.keys(form).length === 0;
                const val = {
                    ...form,
                    ...(isFormEmpty && { startOfMonth, endOfMonth }),
                    page: currentPage,
                };
                if (isFormEmpty) {
                    await dispatch(GetAllRecords(val));
                }
                dispatch(setLoader(false))
            } catch (error) {
                dispatch(setLoader(false))
            }
        })();
    }, [dispatch]);
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current?.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const columns = [
        {
            title: "From", dataIndex: "from", key: "from", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "To", dataIndex: "to", key: "to", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Request#", dataIndex: "requestId", key: "requestId", align: "center", width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Client Name", dataIndex: "clientName", key: "clientName", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>
        },
        {
            title: "Processed By", dataIndex: "processedBy", key: "Processed By", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text || 'N/A'}</span>
        },
        {
            title: "Process Type", dataIndex: "processType", key: "processType", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : 'N/A'
        },
        {
            title: "Request Type", dataIndex: "quoteType", key: "quoteType", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : 'N/A'
        },
        {
            title: "Department", dataIndex: "department", key: "department", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <span title={text}>{text ? text?.length > 15 ? `${text.slice(0, 15)}...` : text : 'N/A'}</span>
        },
        {
            title: "Request Received Date & Time", dataIndex: "date", key: "date", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{text ? dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a") : 'N/A'}</div>
        },
        {
            title: "Request Due Date & Time", dataIndex: "dueDate", key: "dueDate", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: (text, record) => <div>{text ? dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a") : dayjs(GetDueDateTemp(record.priority)).format('DD/MM/YYYY h:mm a')}</div>
        },
        {
            title: "Completed Date & Time", dataIndex: "completedDate", key: "completedDate", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{text ? dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a") : 'Pending'}</div>
        },
        {
            title: "Number of Time Records", dataIndex: "historyCount", key: "TimeRecords", align: "center", width: 160,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : '0'
        },
        {
            title: "Number of Transactions", dataIndex: "noofQuotes", key: "noofQuotes", align: "center", width: 160,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => text ? text : '0'
        },
        {
            title: "Billable Time", dataIndex: "billable", key: "billable", align: "center", width: 130,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{ConvertMsIntoTime(text)}</div>
        },
        {
            title: "Non-Billable Time", dataIndex: "Non_billable", key: "Non_billable", align: "center", width: 150,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: text => <div>{ConvertMsIntoTime(text)}</div>
        },
        {
            title: "Total Time Spent on WO", dataIndex: "totalTimeSpent", key: "totalTimeSpent", align: "center", width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: (text, record) => <div>{addDurations(record.billable, record.Non_billable)}</div>
        },
        {
            title: "SLA", dataIndex: "sla", key: "sla", align: "center", width: 80,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
            render: (text, record) => <div>{checkDueStatus(record.dueDate, record.completedDate)}</div>
        },
    ];
    const totalBillable = tableData?.reduce((sum, rec) => sum + (rec.billable || 0), 0);
    const totalNonBillable = tableData?.reduce((sum, rec) => sum + (rec.Non_billable || 0), 0);
    const totalNumberofQuotes = tableData?.reduce((sum, rec) => sum + (rec.noofQuotes || 0), 0);

    
    const exportFormatters = {
        date: val => dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a"),
        dueDate: (val, rec) => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : dayjs(GetDueDateTemp(rec.priority)).format("DD/MM/YYYY h:mm a"),
        completedDate: val => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : "Pending",
        billable: val => ConvertMsIntoTime(val),
        Non_billable: val => ConvertMsIntoTime(val),
        totalTimeSpent: (val, rec) => addDurations(rec.billable, rec.Non_billable),
        sla: (val, rec) => checkDueStatus(rec.dueDate, rec.completedDate),
        totalTime: ConvertMsIntoTime(overalTime),
        totalBillable: () => ConvertMsIntoTime(totalBillable),
        totalNonBillable: () => ConvertMsIntoTime(totalNonBillable),
        totalNumberofQuotes: totalNumberofQuotes,
    };
    const columnKeys = columns?.map(col => col.key);
    const selectedColumns = [
        "S.No",
        ...columnKeys,
        "RequestCompleted",
        "Start Date Override",
        "Due Date Override",
        "Insured Name",
        "Subject"
    ];


    const formattedData = tableData?.map((record ,idx)=> {
        const row = {};
         row["S.No"] = idx + 1;
        columns?.forEach(col => {
            let value;

            if (exportFormatters[col.dataIndex]) {
                value = exportFormatters[col.dataIndex](record[col.dataIndex], record);
            } else {
                value = record[col.dataIndex];
            }

            row[col.key] = value ?? '-';
        });

        row["RequestCompleted"] = record?.isCompleted ? "Yes" : "No";
        row["Request Type"] = record?.quoteType || "-";
        row["Request Received Date"] = record?.date ? dayjs(parseInt(record.date)).format("DD/MM/YYYY h:mm a") : "-";
        row["Start Date Override"] = record?.startDateOverride ? dayjs(parseInt(record.startDateOverride)).format("DD/MM/YYYY") : "-";
        row["Due Date Override"] = record?.dueDateOverride ? dayjs(parseInt(record.dueDateOverride)).format("DD/MM/YYYY") : "-";
        row["Insured Name"] = record?.insuredName || "-"
        row["Subject"] = record?.subject || "-"

        return row;
    }) || [];

    const totalRow = {};

    columns.forEach((col, index) => {
        if (col.key === 'billable') {
            totalRow[col.key] = ConvertMsIntoTime(totalBillable);
        } else if (col.key === 'Non_billable') {
            totalRow[col.key] = ConvertMsIntoTime(totalNonBillable);
        }
         else if (col.key === 'noofQuotes') {
            totalRow[col.key] = totalNumberofQuotes;
        } else if (col.key === 'totalTime' || col.key === 'totalTimeSpent') {
            totalRow[col.key] = ConvertMsIntoTime(overalTime);
        } else if (index === 0) {
            totalRow[col.key] = 'Total';
        } else {
            totalRow[col.key] = '';
        }
    });

    if (formattedData.length > 0) {
        const allKeys = Object.keys(formattedData[0]);

        allKeys.forEach(key => {
            if (totalRow[key] === undefined) {
                totalRow[key] = '-';
            }
        });
        totalRow["S.No"] = "";
    }

    formattedData.push(totalRow);

    return (
        <div className="page-wrapper px-4">

            {/* ── Filter Toolbar ── */}
            <div className="cr-bar">

                {/* Row 1: date range filters + Client Name + Subject */}
                <div className="cr-row-1">

                    <div className="cr-field cr-date">
                        <span className="cr-label">Received From</span>
                        <DatePickerField
                            classname="form-control"
                            name="requestReceivedFrom"
                            placeholder="From"
                            value={form?.requestReceivedFrom ? dayjs(form.requestReceivedFrom) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "requestReceivedFrom")}
                            onKeyDown={handleKeyDown}
                            disabledDate={(current) =>
                                form.requestReceivedTo ? current && current > dayjs(form.requestReceivedTo).endOf('day') : false
                            }
                        />
                    </div>

                    <div className="cr-field cr-date">
                        <span className="cr-label">Received To</span>
                        <DatePickerField
                            classname="form-control"
                            name="requestReceivedTo"
                            placeholder="To"
                            value={form?.requestReceivedTo ? dayjs(form.requestReceivedTo) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "requestReceivedTo")}
                            onKeyDown={handleKeyDown}
                            disabledDate={(current) =>
                                form.requestReceivedFrom ? current && current < dayjs(form.requestReceivedFrom).startOf('day') : false
                            }
                        />
                    </div>

                    <div className="cr-field cr-date">
                        <span className="cr-label">Due Date From</span>
                        <DatePickerField
                            classname="form-control"
                            name="requestDueFrom"
                            placeholder="From"
                            value={form?.requestDueFrom ? dayjs(form.requestDueFrom) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "requestDueFrom")}
                            onKeyDown={handleKeyDown}
                            disabledDate={(current) =>
                                form.requestDueTo ? current && current > dayjs(form.requestDueTo).endOf('day') : false
                            }
                        />
                    </div>

                    <div className="cr-field cr-date">
                        <span className="cr-label">Due Date To</span>
                        <DatePickerField
                            classname="form-control"
                            name="requestDueTo"
                            placeholder="To"
                            value={form?.requestDueTo ? dayjs(form.requestDueTo) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "requestDueTo")}
                            onKeyDown={handleKeyDown}
                            disabledDate={(current) =>
                                form.requestDueFrom ? current && current < dayjs(form.requestDueFrom).startOf('day') : false
                            }
                        />
                    </div>

                    <div className="cr-field cr-client">
                        <span className="cr-label">Client Name</span>
                        <SelectInput
                            formControl
                            name="clientName"
                            placeholder="Client Name"
                            value={form.clientName}
                            onChange={(val) => handleInputChange({ target: { name: "clientName", value: val } })}
                            options={activeClientOptions}
                        />
                    </div>

                    <div className="cr-field cr-subject">
                        <span className="cr-label">Subject</span>
                        <InputField
                            formControl={true}
                            name="subject"
                            placeholder="Subject"
                            value={form?.subject || ""}
                            onChange={(e) => handleInputChange(e)}
                        />
                    </div>

                </div>

                {/* Row 2: Insured + Billable left-grouped, action buttons right-grouped */}
                <div className="cr-row-2">

                    <div className="cr-row-2-left">
                        <div className="cr-field cr-insured">
                            <span className="cr-label">Insured Name</span>
                            <InputField
                                formControl={true}
                                name="insuredName"
                                placeholder="Insured Name"
                                value={form.insuredName || ""}
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>

                        <div className="cr-field cr-billable">
                            <span className="cr-label">Billable</span>
                            <SelectInput
                                formControl
                                name="billable"
                                placeholder="Billable"
                                value={form?.billable}
                                onChange={(val) => handleInputChange({ target: { name: "billable", value: val } })}
                                options={getOptionsByPath(NestedDatabucket, [REPORTS, REPORTS_BILLABLE])}
                            />
                        </div>
                    </div>

                    <div className="cr-actions">
                        <Tooltip title="Refresh">
                            <button className="cr-icon-btn" onClick={handleClear} type="button">
                                <FontAwesomeIcon icon={faArrowsRotate} />
                            </button>
                        </Tooltip>
                        <AntdButton
                            size="medium" label="Search" type="primary"
                            onClick={handleSubmit}
                            disabled={Object.keys(dateErrors).length > 0}
                            style={{ backgroundColor: "#0a5fd6", borderColor: "#0a5fd6", color: "#fff" }}
                        />
                        <AntdButton
                            size="medium" label="Clear"
                            onClick={handleClear}
                            style={{ backgroundColor: "#6c757d", borderColor: "#6c757d", color: "#fff" }}
                        />
                        <div style={{ position: "relative" }}>
                            <AntdButton
                                onClick={toggleDropdown} label="Export ▾"
                                size="medium"
                                type="primary"
                                style={{ backgroundColor: "#0a5fd6", borderColor: "#0a5fd6", color: "#fff" }}
                            />
                            {dropdownOpen && (
                                <ul ref={dropdownRef} className="cr-dropdown">
                                    <li onClick={() => { handleExport("CSV", selectedColumns, formattedData); setDropdownOpen(false); }}>CSV</li>
                                    <li onClick={() => { handleExport("PDF", selectedColumns, formattedData); setDropdownOpen(false); }}>PDF</li>
                                </ul>
                            )}
                        </div>
                    </div>

                </div>

                {(dateErrors.received || dateErrors.due) && (
                    <div className="cr-errors">
                        {dateErrors.received && <span className="cr-error">{dateErrors.received}</span>}
                        {dateErrors.due && <span className="cr-error">{dateErrors.due}</span>}
                    </div>
                )}

            </div>

            <div className="mt-2">
                <CustomGridTable
                    columns={columns}
                    Id="record-client-report-table"
                    dataSource={tableData}
                    rowKey="rowId"
                    pagination={{
                        current: currentPage,
                        onChange: page => setCurrentPage(page),
                        pageSize: 100,
                        total: data?.totalCount,
                        showSizeChanger: false
                    }}
                    scroll={{ x: false }}
                    size="small"
                    footer={() => (
                        <div>
                            <strong>Total Duration: </strong>{" "}
                            {ConvertMsIntoTime(overalTime)}
                        </div>
                    )}
                />
            </div>

            <style jsx="true">{`
                /* ── Toolbar shell ── */
                .cr-bar {
                    background: #fff;
                    border: 1px solid #e5e7eb;
                    border-radius: 6px;
                    padding: 16px 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                    margin-bottom: 12px;
                }

                /* ── Row 1: date pickers + Client Name + Subject ── */
                .cr-row-1 {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-end;
                    gap: 16px;
                }

                /* ── Row 2: Insured+Billable left-grouped, buttons pinned right ── */
                .cr-row-2 {
                    display: flex;
                    align-items: flex-end;
                    gap: 16px;
                }

                /* ── Left group of row 2 ── */
                .cr-row-2-left {
                    display: flex;
                    align-items: flex-end;
                    gap: 16px;
                }

                /* ── Each filter: label stacked above control ── */
                .cr-field {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                /* ── DatePickerField and SelectInput both render inside
                   <div class="input-block mb-3">. That 16px margin-bottom
                   makes them 16px taller than InputField (which renders a
                   bare React Fragment). With align-items:flex-end this
                   pushes all InputField labels 16px lower. Zero it out. ── */
                .cr-bar .input-block {
                    margin-bottom: 0 !important;
                }
                .cr-bar .ant-form-item {
                    margin-bottom: 0 !important;
                }

                /* ── Labels ── */
                .cr-label {
                    font-size: 12px;
                    font-weight: 500;
                    color: #374151;
                    white-space: nowrap;
                    line-height: 1.2;
                }

                /* ── Date pickers ── */
                .cr-date {
                    flex: 0 0 165px;
                    min-width: 155px;
                }
                .cr-date .ant-picker {
                    width: 100% !important;
                    height: 32px !important;
                    font-size: 13px !important;
                }
                .cr-date .ant-picker .ant-picker-input > input {
                    font-size: 13px !important;
                }

                /* ── Client dropdown ── */
                .cr-client {
                    flex: 0 0 195px;
                    min-width: 175px;
                }
                .cr-client .ant-select {
                    width: 100% !important;
                    min-width: 0 !important;
                }

                /* ── Subject: fills remaining row-1 space ── */
                .cr-subject {
                    flex: 1 1 200px;
                    min-width: 180px;
                }
                .cr-subject .ant-input { width: 100% !important; }

                /* ── Insured Name: 165px = same as date columns,
                   creates implicit vertical grid alignment with row 1 ── */
                .cr-insured {
                    flex: 0 0 165px;
                    min-width: 155px;
                }
                .cr-insured .ant-input { width: 100% !important; }

                /* ── Billable: 165px = same as date columns,
                   aligns with "Received To" column above it ── */
                .cr-billable {
                    flex: 0 0 165px;
                    min-width: 155px;
                }
                .cr-billable .ant-select {
                    width: 100% !important;
                    min-width: 0 !important;
                }

                /* ── Normalize all control heights ── */
                .cr-bar .ant-select-selector {
                    height: 32px !important;
                    min-height: 32px !important;
                }
                .cr-bar .ant-select-selection-placeholder,
                .cr-bar .ant-select-selection-item {
                    line-height: 30px !important;
                    font-size: 13px !important;
                }
                .cr-bar .ant-input {
                    height: 32px !important;
                    min-height: 32px !important;
                    font-size: 13px !important;
                    padding: 4px 10px !important;
                    box-sizing: border-box !important;
                    width: 100% !important;
                }

                /* ── Action buttons: margin-left:auto pushes them to the far right
                   while keeping them physically adjacent in the DOM ── */
                .cr-actions {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-left: auto;
                    flex-shrink: 0;
                }

                .cr-icon-btn {
                    width: 32px;
                    height: 32px;
                    border: none;
                    border-radius: 4px;
                    background: transparent;
                    color: #1d6fdc;
                    cursor: pointer;
                    font-size: 18px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    transition: background 0.15s;
                    flex-shrink: 0;
                }
                .cr-icon-btn:hover {
                    background: #e8f1fc;
                }

                /* ── Validation errors ── */
                .cr-errors {
                    display: flex;
                    gap: 24px;
                }
                .cr-error {
                    font-size: 11px;
                    color: #ef4444;
                    line-height: 1.3;
                }

                /* ── Export dropdown ── */
                .cr-dropdown {
                    position: absolute;
                    right: 0;
                    top: calc(100% + 3px);
                    z-index: 300;
                    background: #fff;
                    border: 1px solid #dde3eb;
                    border-radius: 5px;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.10);
                    list-style: none;
                    margin: 0;
                    padding: 4px 0;
                    min-width: 88px;
                }
                .cr-dropdown li {
                    padding: 7px 16px;
                    font-size: 13px;
                    color: #374151;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: background 0.1s;
                }
                .cr-dropdown li:hover { background: #f3f4f6; }
            `}</style>
        </div>
    );
};